export const iconFontAwesomeMathematicsNotEqual = (
	<i className="fa-solid fa-not-equal"></i>
);
